import { render, staticRenderFns } from "./SettingPanel.vue?vue&type=template&id=a6f724da&scoped=true"
import script from "./SettingPanel.vue?vue&type=script&lang=js"
export * from "./SettingPanel.vue?vue&type=script&lang=js"
import style0 from "./SettingPanel.vue?vue&type=style&index=0&id=a6f724da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f724da",
  null
  
)

export default component.exports